import { render, staticRenderFns } from "./AppCostsInfoVehicle.vue?vue&type=template&id=4742d4fe&scoped=true&"
import script from "./AppCostsInfoVehicle.vue?vue&type=script&lang=js&"
export * from "./AppCostsInfoVehicle.vue?vue&type=script&lang=js&"
import style0 from "./AppCostsInfoVehicle.vue?vue&type=style&index=0&id=4742d4fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4742d4fe",
  null
  
)

export default component.exports